import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Header } from "../Header/Header";
import { HomePage } from "../../pages/Home/HomePage";
import { ProjectPage } from "../../pages/Project/ProjectPage";
import { BrainGamePage } from "../../pages/BrainGame/BrainGamePage";

const Routing = () => {
    return (<>
     <Router>
        <Header ></Header>
        <Routes>
          <Route path="/projects" Component={ProjectPage} />
          <Route path="/projects/:id" Component={ProjectPage} />
          <Route path="/projects/:id/:command" Component={ProjectPage} />
          <Route path="/braingame/:id" Component={BrainGamePage} />
          <Route path="/" Component={HomePage} />
          <Route path="*" Component={HomePage} />
        </Routes>
      </Router>
    </>);
}

export { Routing };
